// extracted by mini-css-extract-plugin
module.exports = {"clearFilter":"ClearFilters_clearFilter__jMY2_","cancelIcon":"ClearFilters_cancelIcon__xd7sz","iconWrap":"ClearFilters_iconWrap__O_bAG"};